module.exports = __webpack_public_path__ + "static/media/ondas2.373bb977.svg";